import React, { useState, useEffect } from "react";
import { Input, DatePicker, Spin } from "antd";
import Pagination from "../../../components/global/pagination/Pagination.jsx";
import columns from "../../../columns/wallet/InternalTransfer.js";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton.jsx";
import { GetAllwalletinternalTransferApi, InternalTransferRequestAcceptRejectApi, GetAllAverageScalpingApi, GetUserScalpingDealsExcelApi, GetRbTradesReportApi } from "../../../api/request/wallet/internalTransfer.js";
import { AdminGetRvTradesApi } from "../../../api/request/client.js";
import { downloadRbReportGroupedExcel } from "./exportRbReportExcel";
import moment from "moment";
import Segmented from "../../../components/segmented/Segmented.jsx";
import Eye from "../../../assets/Eye.jsx";
import ModalComponent from "../../../components/global/modal/ModalComponent.jsx";
import ConfirmationModal from "../../../components/global/modal/ConfirmationModal.jsx";
import toast from "react-hot-toast";
import ExportHandler from "../../../components/global/export/ExportHandler.jsx";
import Support from "../../../assets/support/Support.jsx";
import { useSelector } from "react-redux";
import UserAvatar from "../../../components/global/avtar/UserAvatar.jsx";
import AcToAc from "./AcToAc.jsx";
import Download from "../../../assets/Download.jsx";

const { RangePicker } = DatePicker;

export default function InternalTransfer() {

  const userDetails = useSelector((state) => state.user.userDetails);
  let isSalesManager = userDetails?.roleId === 6;

  const [pageSize, setPageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [rawData, setRawData] = useState([]);
  const [dataScalping, setDataScalping] = useState('');
  const [totalRecord, setTotalRecord] = useState(0);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [search, setSearch] = useState('');
  const [dates, setDates] = useState([]);
  const [value, setValue] = useState("Pending");
  const [selectedInternalTransfer, setselectedInternalTransfer] = useState("");
  const [selectedInternalTransferid, setselectedInternalTransferId] = useState("");
  const [InternalTransferAccept, setInternalTransferAccept] = useState(false);
  const [InternalTransferRejection, setInternalTransferRejection] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalDeal, setIsOpenModalDeal] = useState(false);
  const [isReqLoading, setIsReqLoading] = useState(false);
  const [textAreaValue, setTextAreaValue] = useState("");
  const [sorter, setSorter] = useState({ SortBy: 'actionDate', SortOrder: '' });
  const [downloadingExcelId, setDownloadingExcelId] = useState(null);

  const getAllInternalTransfer = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        SearchText: searchText,
        FromDate: dates.length === 2 ? dates[0].format('MM-DD-YYYY') : '',
        ToDate: dates.length === 2 ? dates[1].format('MM-DD-YYYY') : '',
        FilterText: value === "Pending"
          ? "Pending"
          : value === "Approved"
            ? "Success"
            : value === "Declined"
              ? "Rejected"
              : value,
        ...sorter
      }
      setIsLoading(true);
      const { data } = await GetAllwalletinternalTransferApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setRawData(data?.data || []);
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  const getAllAverageScalping = async (id) => {
    try {

      setIsLoading(true);
      const { data } = await GetAllAverageScalpingApi(id);
      if (data?.success) {
        setDataScalping(data?.data);
      }
      setIsLoading(false);
    } catch (error) {
      setDataScalping(null)
      setIsLoading(false);
    }
  }

  const downloadExcelFromBlobResponse = (blobData, headers) => {
    const disposition = headers?.["content-disposition"] || headers?.["Content-Disposition"];

    let fileName = "User Scalping Deals.xlsx";
    if (disposition) {
      const filenameStarMatch = disposition.match(/filename\*\s*=\s*([^;]+)/i);
      const filenameMatch = disposition.match(/filename\s*=\s*"?([^\";]+)"?/i);

      if (filenameStarMatch?.[1]) {
        const raw = filenameStarMatch[1].trim().replace(/UTF-8''/i, "");
        fileName = decodeURIComponent(raw.replace(/"/g, ""));
      } else if (filenameMatch?.[1]) {
        fileName = filenameMatch[1].trim();
      }
    }

    const contentType =
      headers?.["content-type"] ||
      headers?.["Content-Type"] ||
      "application/octet-stream";

    const blob =
      blobData instanceof Blob
        ? blobData
        : new Blob([blobData], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleDownloadScalpingDeals = async (id) => {
    try {
      if (!id) return;
      setDownloadingExcelId(id);
      const response = await GetUserScalpingDealsExcelApi(id);
      downloadExcelFromBlobResponse(response?.data, response?.headers);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setDownloadingExcelId(null);
    }
  };

  const handleDownloadRbReportExcel = async (item) => {
    try {
      setDownloadingExcelId(item?.id);
      const { data } = await GetRbTradesReportApi(item?.id);
      if (!data?.success) {
        toast.error(data?.message);
        return;
      }
      const details = data?.data?.rvTradeDetails;
      if (!details?.length) {
        toast.error("No RB report data to export.");
        return;
      }
      await downloadRbReportGroupedExcel(data?.data, `RbReport_${item?.accountNo}`);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setDownloadingExcelId(null);
    }
  };
  const handleTableChange = (sorter) => {
    if (sorter?.order) {
      setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
    } else {
      setSorter({ SortBy: 'actionDate', SortOrder: '' });
    }
  };

  const tableData = rawData?.map((item) => ({
    ...item,
    key: item?.key || item?.id,
    name: (
      <UserAvatar
        data={{ name: `${item?.firstName} ${item?.lastName}`, email: item?.email }}
      />
    ),
    amount: `$ ${item?.amount}`,
    transactionDate: item?.transactionDate
      ? moment(item?.transactionDate).format("DD-MM-YYYY, hh:mm A")
      : "--",
    actionDate: item?.actionDate ? moment(item?.actionDate).format("DD-MM-YYYY, hh:mm A") : "--",
    status:
      item?.status == "Approved" ? (
        <span className="px-3 py-1 rounded-full uppercase text-xs text-center success_tag">
          {item?.status}
        </span>
      ) : (
        <span className="uppercase px-3 py-1 rounded-full text-xs text-center fail_tag">
          {item?.status}
        </span>
      ),
    actions: (
      <div className="flex items-center gap-2">
        <button type="button" onClick={() => { setselectedInternalTransfer(item); setIsOpenModal(true); }}>
          <Eye />
        </button>
        {
          item?.isRBWithdraw ?
            <button type="button" disabled={downloadingExcelId === item?.id} onClick={() => handleDownloadRbReportExcel(item)}>
              {downloadingExcelId === item?.id ? <Spin size="small" /> : <Download />}
            </button>
            : item?.actionBy == " " && (<button type="button" disabled={downloadingExcelId === item?.id} onClick={() => handleDownloadScalpingDeals(item?.id)}>
              {downloadingExcelId === item?.id ? <Spin size="small" /> : <Download />}
            </button>)
        }
      </div>
    ),
  }));

  useEffect(() => {
    getAllInternalTransfer();
  }, [page, pageSize, searchText, dates, value, sorter]);

  useEffect(() => {
    setPage(1);
  }, [searchText]);

  const exportHandler = async () => {
    try {
      let params = {
        ApplyPagination: false,
        SearchText: searchText,
        FromDate: dates.length === 2 ? dates[0].format('MM-DD-YYYY') : '',
        ToDate: dates.length === 2 ? dates[1].format('MM-DD-YYYY') : '',
        FilterText: value === "Pending"
          ? "Pending"
          : value === "Approved"
            ? "Success"
            : value === "Declined"
              ? "Rejected"
              : value,
        ...sorter,
      };
      const { data } = await GetAllwalletinternalTransferApi(new URLSearchParams(params).toString());
      if (data?.success) {
        return { data: data?.data, removableColumns: ['userId', 'id'], fileName: 'Internal Transfer List' };
      } else {
        return { data: [], removableColumns: [] };
      }
    } catch (error) {
      return { data: [], removableColumns: [] };
    }
  };

  const RequestHandlerApproved = async (value) => {
    if (!value) {
      if (!textAreaValue) {
        toast.error("Please enter a reason.");
        return;
      }
    }
    try {
      setIsReqLoading(true);
      let params = {

        comment: textAreaValue ? textAreaValue : "Accepted.",
        requestId: selectedInternalTransferid,
        status: 1,
        approvedReject: true,
      };
      const { data } = await InternalTransferRequestAcceptRejectApi(params);
      if (data?.success) {
        toast.success(data?.message);
        setIsOpenModal(false);
      }
      getAllInternalTransfer();
      setTextAreaValue("");
      setIsReqLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsReqLoading(false);
    }
    if (value) {
      setInternalTransferAccept(false);
    } else {
      setInternalTransferRejection(false);
    }
  };

  const RequestHandlerRejected = async (value) => {
    if (!value) {
      if (!textAreaValue) {
        toast.error("Please enter a reason.");
        return;
      }
    }
    try {
      setIsReqLoading(true);
      let params = {
        comment: textAreaValue ? textAreaValue : "Accepted.",
        requestId: selectedInternalTransferid,
        status: 4,
        approvedReject: false,
      };
      const { data } = await InternalTransferRequestAcceptRejectApi(params);
      if (data?.success) {
        toast.success(data?.message);
        setIsOpenModal(false);
      }
      getAllInternalTransfer();
      setTextAreaValue("");
      setIsReqLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsReqLoading(false);
    }
    if (value) {
      setInternalTransferAccept(false);
    } else {
      setInternalTransferRejection(false);
    }
  };

  return (
    <div>
      <div className="flex flex-wrap justify-between gap-5">
        <div>
          <Segmented
            options={["Pending", "Approved", "Declined"]}
            value={value}
            setValue={setValue}
          />
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <RangePicker className='py-1.5 rounded-lg' format='DD-MM-YYYY' onChange={(dates) => setDates(dates || [])} />

          <div>
            <Input
              size="large"
              style={{ width: 220 }}
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onPressEnter={() => setSearchText(search)}
              prefix={
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                  <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clip-rule="evenodd" />
                </svg>
              }
              suffix={search &&
                <svg xmlns="http://www.w3.org/2000/svg" onClick={() => { setSearchText(''); setSearch('') }} viewBox="0 0 24 24" fill="#bebebe" className="size-5 cursor-pointer duration-300 hover:fill-[#969595]">
                  <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clip-rule="evenodd" />
                </svg>
              }
            />
          </div>

          <div>
            <ExportHandler exportHandler={exportHandler} />
          </div>

          <AcToAc />
        </div>
      </div>

      <div className="my-6">
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={tableData}
            loading={isLoading}
            onChange={handleTableChange}
            hiddenColumns={isSalesManager ? ["Actions"] : []}
            page={page}
            pageSize={pageSize}
            index={true}
          />
        </div>
        <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
      </div>

      <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title="InternalTransfer Information" width={1300}>
        <div className='sm:p-5 p-3'>
          <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
            <div>
              <p className='text-description font-normal '>First Name</p>
              <p className='text-description primary font-semibold  mt-2'>{selectedInternalTransfer?.firstName || "--"}</p>
            </div>
            <div>
              <p className='text-description font-normal '>Last Name</p>
              <p className='text-description primary font-semibold  mt-2'>{selectedInternalTransfer?.lastName || "--"}</p>
            </div>
            <div>
              <p className='text-description font-normal'> Wallet AccountNo</p>
              <p className='text-description primary font-semibold  mt-2'>{selectedInternalTransfer?.walletAccountNo || "--"}</p>
            </div>
            <div>
              <p className='text-description font-normal '>Available Wallet Balance</p>
              <p className='text-description primary font-semibold  mt-2'>$ {selectedInternalTransfer?.availableWalletBalance}</p>
            </div>

            <div>
              <p className='text-description font-normal '>Mobile No.</p>
              <p className='text-description primary font-semibold  mt-2'>{selectedInternalTransfer?.phoneNo || "--"}</p>
            </div>
            <div>
              <p className='text-description font-normal '>Email</p>
              <p className='text-description primary font-semibold  mt-2'>{selectedInternalTransfer?.email || "--"}</p>
            </div>
            <div>
              <p className='text-description font-normal '>Status</p>
              <p className='text-description primary font-semibold  mt-2'>{selectedInternalTransfer?.status || '--'}</p>
            </div>
            <div>
              <p className='text-description font-normal '>Country Name</p>
              <p className='text-description primary font-semibold  mt-2'>{selectedInternalTransfer?.countryName || "--"}</p>
            </div>

            <div>
              <p className='text-description font-normal '>Account No</p>
              <p className='text-description primary font-semibold mt-2'> {selectedInternalTransfer?.accountNo || "--"}</p>
            </div>
            <div>
              <p className='text-description font-normal '>Amount</p>
              <p className='text-description primary font-semibold mt-2'>$ {selectedInternalTransfer?.amount || "--"}</p>
            </div>
            <div>
              <p className='text-description font-normal '>Comment</p>
              <p className='text-description primary font-semibold mt-2'> {selectedInternalTransfer?.remarks || "--"}</p>
            </div>
            <div>
              <p className='text-description font-normal '>Created Date</p>
              <p className='text-description primary font-semibold mt-2'> {selectedInternalTransfer?.createdDate ? moment(selectedInternalTransfer?.createdDate).format("LLL") : "--" || "--"}</p>
            </div>
          </div>
          {!(selectedInternalTransfer?.status === "Approved" || selectedInternalTransfer?.status === "Rejected") && (
            <div className="flex justify-center items-center">
              <div className="mt-8 flex">
                <button
                  onClick={() => { setselectedInternalTransferId(selectedInternalTransfer?.id); setInternalTransferAccept(true) }}
                  className="bg-[#2D9B6333] text-sm text-[#2D9B63] font-semibold px-4 py-2 rounded-lg uppercase hover:bg-[#2D9B63] hover:text-white duration-500"
                >
                  Accept
                </button>
                <button
                  onClick={() => { setselectedInternalTransferId(selectedInternalTransfer?.id); setInternalTransferRejection(true) }}
                  className="bg-[#F8222333] text-sm text-[#F82223] font-semibold px-4 py-2 rounded-lg uppercase hover:bg-[#F82223] hover:text-white duration-500 ml-4"
                >
                  Reject
                </button>
                <button type="button" className="flex items-center gap-1 text-sm font-semibold px-4 py-2 rounded-lg uppercase underline primary ml-4" onClick={() => { getAllAverageScalping(selectedInternalTransfer?.accountNo); setIsOpenModalDeal(true); }}><Support /> Average Scalping </button>
              </div>
            </div>
          )}
        </div>

      </ModalComponent>

      <ModalComponent isOpen={isOpenModalDeal} setIsOpen={setIsOpenModalDeal} title="Average Scalping" width={800}>
        <div className='p-5'>
          {dataScalping === null ?
            <div className="text-center">
              <p className='text-description font-normal'>No data found.</p>
            </div> :
            <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
              <div>
                <p className='text-description font-normal '>Name</p>
                <p className='text-description primary font-semibold  mt-2'>{dataScalping?.name || "--"}</p>
              </div>
              <div>
                <p className='text-description font-normal '>Account No</p>
                <p className='text-description primary font-semibold  mt-2'>{dataScalping?.loginId || "--"}</p>
              </div>
              <div>
                <p className='text-description font-normal '>Average Duration</p>
                <p className='text-description primary font-semibold  mt-2'>{dataScalping?.avgDuration || "--"}</p>
              </div>
              <div>
                <p className='text-description font-normal '>Total Trade</p>
                <p className='text-description primary font-semibold  mt-2'>{dataScalping?.totalTrade || "--"}</p>
              </div>
              <div>
                <p className='text-description font-normal'>Trade Duration</p>
                <p className='text-description primary font-semibold  mt-2'>{dataScalping?.tradeDuration || "--"}</p>
              </div>
            </div>
          }
        </div>
      </ModalComponent>

      {/* ---- Accept-request ---- */}
      <ConfirmationModal
        isOpen={InternalTransferAccept}
        setIsOpen={setInternalTransferAccept}
        type="success"
        message="Are you sure you want to accept this request?"
        onConfirm={() => RequestHandlerApproved(true)}
        isLoading={isReqLoading}
        loadingLabel="Accepting request..."
      />

      {/* ---- Reject-request ---- */}
      <ConfirmationModal
        isOpen={InternalTransferRejection}
        setIsOpen={setInternalTransferRejection}
        message="Are you sure you want to reject this request?"
        onConfirm={() => RequestHandlerRejected(false)}
        isLoading={isReqLoading}
        loadingLabel="Rejecting request..."
        textArea={true}
        textAreaValue={textAreaValue}
        setTextAreaValue={setTextAreaValue}
        placeholder="Reason of rejection..."
      />
    </div>
  )
}


